



















































import { defineNuxtComponent } from '~/utils/nuxt3-migration'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineNuxtComponent({
  components: { CImg },
  i18n: defineComponentTranslations({
    advertise_easily: {
      en: 'Advertise easily',
      el: 'Διαφήμισε εύκολα'
    },
    your_business: {
      en: 'your business',
      el: 'την επιχείρησή σου'
    }
  })
})
